import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { RecoilRoot } from 'recoil';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import AutoRefreshApp from './AutoRefreshApp'; // Import the new component

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <AutoRefreshApp /> {/* Use AutoRefreshApp instead of wrapping App with Router */}
      </MuiPickersUtilsProvider>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);
